import { Form, Link } from "@remix-run/react";
import { StrongAuthLogin } from "~/components/forms/strong-auth-login";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";
import { Input } from "~/components/ui/input";

import SignInButton from "../SignInButton/SignInButton";
import type { FormFieldType } from "./form-builder";
import FormBuilder from "./form-builder";

export function LoginForm({
  error,
  apiUrl,
  passwordLoginEnabled = true,
}: {
  error: string | undefined;
  apiUrl?: string;
  passwordLoginEnabled?: boolean;
}): JSX.Element {
  const forgotPasswordRoute = "/forgot-password";
  const loginFields: FormFieldType[] = [
    {
      id: "login-email",
      label: "Sähköposti",
      type: "email",
      name: "email",
      placeholder: "nimi@esimerkki.fi",
      required: true,
      screenReaderDescription:
        "Syötä sähköpostiosoitteesi kirjautumista varten",
      Component: Input,
    },
    {
      id: "login-password",
      label: "Salasana",
      type: "password",
      name: "password",
      placeholder: "••••••••",
      error,
      required: true,
      screenReaderDescription: "Syötä salasanasi kirjautumista varten",
      Component: Input,
    },
  ];

  return (
    <Card className="w-[350px]" role="main" aria-labelledby="login-title">
      <CardHeader>
        <CardTitle id="login-title">Kirjaudu sisään</CardTitle>
        <CardDescription>Syötä kirjautumistietosi jatkaaksesi</CardDescription>
      </CardHeader>
      <CardContent>
        <>
          {passwordLoginEnabled && (
            <>
              <Form method="post">
                <FormBuilder fields={loginFields}>
                  <SignInButton />
                </FormBuilder>
              </Form>
              <div className="mt-4 text-center">
                <Link
                  to={forgotPasswordRoute}
                  className="text-sm text-muted-foreground hover:underline"
                >
                  Unohditko salasanasi?
                </Link>
              </div>
            </>
          )}

          {apiUrl && (
            <div className={passwordLoginEnabled ? "mt-6 border-t pt-6" : ""}>
              <StrongAuthLogin
                apiUrl={apiUrl}
                userType="employee"
                buttonText="Vahva tunnistautuminen"
              />
            </div>
          )}
        </>
      </CardContent>
    </Card>
  );
}
